import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf, Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--brand-dark)',
      color: 'white',
      padding: '64px 12px 32px',
    }}>
      <div className="container" style={{ maxWidth: '1440px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '48px',
          marginBottom: '48px',
        }}>
          {/* Company Info */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <img 
                src="/logo.jpeg" 
                alt="Nouveau Départ Logo"
                style={{ height: '45px', width: 'auto' }}
              />
              <span style={{ fontSize: '20px', fontWeight: '600' }}>Nouveau Départ</span>
            </div>
            <p style={{ fontSize: '16px', lineHeight: '1.6', opacity: '0.9', marginBottom: '24px' }}>
              Expert en solutions d'énergie renouvelable pour un avenir durable. Installations certifiées RGE.
            </p>
            <div style={{ display: 'flex', gap: '16px' }}>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
                <Facebook size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
                <Twitter size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
                <Linkedin size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>Liens rapides</h3>
            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Accueil
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/solutions" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Solutions
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/devis" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Demander un devis
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/contact" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>Nos solutions</h3>
            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/solutions/solaire" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Énergie Solaire
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/solutions/chauffage" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Chauffage Écologique
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/solutions/isolation" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Isolation Thermique
                </Link>
              </li>
              <li style={{ marginBottom: '12px' }}>
                <Link to="/devis" style={{ color: 'white', textDecoration: 'none', fontSize: '16px', opacity: '0.9', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '1'} onMouseOut={(e) => e.target.style.opacity = '0.9'}>
                  Aides & Financements
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '16px' }}>Contact</h3>
            <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
              <li style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', fontSize: '16px', opacity: '0.9' }}>
                <Phone size={18} />
                <a href="tel:0175438580" style={{ color: 'white', textDecoration: 'none' }}>01 75 43 85 80</a>
              </li>
              <li style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px', fontSize: '16px', opacity: '0.9' }}>
                <Mail size={18} />
                <a href="mailto:contact@nvdepart.fr" style={{ color: 'white', textDecoration: 'none' }}>contact@nvdepart.fr</a>
              </li>
              <li style={{ display: 'flex', alignItems: 'start', gap: '12px', fontSize: '16px', opacity: '0.9' }}>
                <MapPin size={18} style={{ marginTop: '4px' }} />
                <span>27 Avenue Viel<br />75017 Paris, France</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '32px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px',
          fontSize: '14px',
          opacity: '0.8',
        }}>
          <p style={{ margin: '0' }}>© 2025 Nouveau Départ. Tous droits réservés.</p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <Link to="/contact" style={{ color: 'white', textDecoration: 'none', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
              Mentions légales
            </Link>
            <Link to="/contact" style={{ color: 'white', textDecoration: 'none', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
              Politique de confidentialité
            </Link>
            <Link to="/contact" style={{ color: 'white', textDecoration: 'none', transition: 'opacity 0.2s' }} onMouseOver={(e) => e.target.style.opacity = '0.7'} onMouseOut={(e) => e.target.style.opacity = '1'}>
              CGV
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
